export enum ContentfulGraphTemplate {
  Bar = 'Barres',
  BusyPeriods = "Horaires d'affluences",
  Pie = 'Camenbert',
  Gsm = 'GSM',
  Gsm_Bourse = 'GSM Bourse',
}

export const graphTypeKeyMapper = {
  default: 'value',
}

export type Value = {
  readonly title: string
  readonly value: number
  readonly color: string
}
export type GraphUIProps = {
  type: ContentfulGraphTemplate
  options?: Record<string, unknown>
  data: DataType
  className?: string
}
export type DataSetType = {
  label: string
  backgroundColor: string[]
  data: number[]
  hidden?: boolean
}

export type DataType = {
  title?: string
  labels: string[]
  colors?: string[]
  datasets: DataSetType[]
}

export type GraphType = {
  type?: ContentfulGraphTemplate
  title: string
  labels: string[]
  datasets: DataSetType[]
  texts: any[]
}
